import { useMutation } from '@tanstack/react-query'
import { TypeSignupApplication } from './useSignUpApplication'
import { post, queryKeys, SignUpUrl } from '@mobi/account/Utils'
import { TypeVerificationResponse } from './useVerifyDriversLicence'

export type TypeMedicareDetailsRequest = TypeSignupApplication & {
  medicareDetails: {
    cardNumber: string
    referenceNumber: string
    cardColour: string
    expiryDay: number
    expiryMonth: number
    expiryYear: number
  }
}

export const useVerifyMedicare = () => {
  const { mutate: verifyMedicare, status: verifyMedicareStatus } = useMutation({
    mutationFn: (medicareDetails: TypeMedicareDetailsRequest): Promise<TypeVerificationResponse> =>
      post(SignUpUrl.verifyMedicare, medicareDetails),
    mutationKey: [queryKeys.signupVerifyMedicare],
  })
  return { verifyMedicare, verifyMedicareStatus }
}
